import axios from 'axios';
import '../styles/components/Navbar.scss';
import { NavLink } from 'react-router-dom';
import SERVER from '../hooks/useServer';

const NavbarAdmin = () => {

    const logout = async () => {
        try{
            const response = await axios.post(`${SERVER}/auth/logout`)
            if (response.status === 200){
                localStorage.removeItem('token')
                window.location.reload()
            }
        }catch(error){
            console.log(error)
        }
    }

    return (
        <div className='navbar'>
            <div className='links'>
                <NavLink to='/'>Accueil</NavLink>
                <button onClick={logout}>Logout</button>
            </div>
        </div>
    );
};

export default NavbarAdmin;